export const tabNames = {
  live: 'live',
  graph: 'graph',
  prediction: 'prediction',
}
